<div class="maintenance-page">
  <div class="maintenance-page__content text-center">
    <img alt="{{ 'errors.maintenance.header' | translate }}" class="img-fluid maintenance-image" src="assets/images/maintenance.png" />
  </div>
</div>
